import {ScopeLevelMaster} from './ScopeLevelMaster';
import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {StringUtils} from '../../utils/string.utils';


export class ChildProgressLevelTracker {
    id: number;
    childId: number;
    scopeProfileReportId: number;
    receptiveLevel: number;
    expressiveLevel: number;
    playLevel: number;
    socialLevel: number;
    cognitionLevel: number;
    imitationLevel: number;
    selfhelpLevel: number;
    finemotorLevel: number;
    receptiveLevelMaster: ScopeLevelMaster;
    expressiveLevelMaster: ScopeLevelMaster;
    playLevelMaster: ScopeLevelMaster;
    socialLevelMaster: ScopeLevelMaster;
    cognitionLevelMaster: ScopeLevelMaster;
    imitationLevelMaster: ScopeLevelMaster;
    selfhelpLevelMaster: ScopeLevelMaster;
    finemotorLevelMaster: ScopeLevelMaster;
    level: number;
    assessedBy: string;
    programSetup: string;
    score: number[];
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;
    // Calculator
    daysPassed: number;

    static populate(jsonObject: any): ChildProgressLevelTracker {
        const obj = new ChildProgressLevelTracker();
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.scopeProfileReportId = jsonObject.scopeProfileReportId;
        obj.receptiveLevel = jsonObject.receptiveLevel;
        obj.expressiveLevel = jsonObject.expressiveLevel;
        obj.playLevel = jsonObject.playLevel;
        obj.socialLevel = jsonObject.socialLevel;
        obj.cognitionLevel = jsonObject.cognitionLevel;
        obj.imitationLevel = jsonObject.imitationLevel;
        obj.selfhelpLevel = jsonObject.selfhelpLevel;
        obj.finemotorLevel = jsonObject.finemotorLevel;
        obj.receptiveLevelMaster = jsonObject.receptiveLevelMaster;
        obj.expressiveLevelMaster = jsonObject.expressiveLevelMaster;
        obj.playLevelMaster = jsonObject.playLevelMaster;
        obj.socialLevelMaster = jsonObject.socialLevelMaster;
        obj.cognitionLevelMaster = jsonObject.cognitionLevelMaster;
        obj.imitationLevelMaster = jsonObject.imitationLevelMaster;
        obj.selfhelpLevelMaster = jsonObject.selfhelpLevelMaster;
        obj.finemotorLevelMaster = jsonObject.finemotorLevelMaster;
        obj.level = jsonObject.level;
        obj.assessedBy = jsonObject.assessedBy;
        obj.programSetup = jsonObject.programSetup;
        obj.score = jsonObject.score;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        // Days Passed
        obj.daysPassed = jsonObject.daysPassed;
        return obj;
    }

    static formPopulate(obj: ChildProgressLevelTracker, jsonObject: any): ChildProgressLevelTracker {
        if (obj == null) {
            obj = new ChildProgressLevelTracker();
        }
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.scopeProfileReportId = jsonObject.scopeProfileReportId;
        obj.receptiveLevel = jsonObject.receptiveLevel;
        obj.expressiveLevel = jsonObject.expressiveLevel;
        obj.playLevel = jsonObject.playLevel;
        obj.socialLevel = jsonObject.socialLevel;
        obj.cognitionLevel = jsonObject.cognitionLevel;
        obj.imitationLevel = jsonObject.imitationLevel;
        obj.selfhelpLevel = jsonObject.selfhelpLevel;
        obj.finemotorLevel = jsonObject.finemotorLevel;
        obj.level = jsonObject.level;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): ChildProgressLevelTracker {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = ChildProgressLevelTracker.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): ChildProgressLevelTracker [] {
        const lst: ChildProgressLevelTracker [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(ChildProgressLevelTracker.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}
